import { ManagedAccount } from '@webdev/user-management';
import React, { useState } from 'react';
import deleteIcon from '../../assets/img/users-delete.svg';
import keyOffIcon from '../../assets/img/users-key-off.svg';
import keyOnIcon from '../../assets/img/users-key-on.svg';
import { useGetLicencesByUser } from './useGetLicencesByUser';
import UserDetails from './UserDetails';
import { useRemoveManagedUser } from './useRemoveManagedUser';

interface UserTableRowProps {
  user: ManagedAccount;
}

export const UserTableRow: React.FC<UserTableRowProps> = ({ user }) => {
  const [open, setOpen] = useState(false);
  const { removeManagedUser } = useRemoveManagedUser();
  const { allocatedLicenses } = useGetLicencesByUser(user.id);

  const toggleDetails = () => setOpen(!open);

  const onRemoveClick: React.MouseEventHandler<HTMLImageElement> = (event) => {
    event.stopPropagation();
    removeManagedUser(user);
  };

  return (
    <>
      <tr
        className={`users__table-row f5 ${open ? 'users__table-row-open' : ''}`}
        onClick={toggleDetails}
      >
        <td
          className={`users__table-row-key ${
            open ? 'users__table-row-key-open' : 'users__table-row-key-closed'
          }`}
        >
          <img alt={open ? 'close' : 'open'} src={open ? keyOffIcon : keyOnIcon} />
        </td>
        <td>{user.email}</td>
        <td>{allocatedLicenses?.length ?? 0}</td>
        <td>{user.status}</td>
        <td className={open ? 'users__table-row-delete-open' : 'users__table-row-delete'}>
          <img src={deleteIcon} alt='Delete User' onClick={onRemoveClick} />
        </td>
      </tr>
      {open && <UserDetails userId={user.id} />}
    </>
  );
};
